import { Inject, Injectable } from '@angular/core';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { HttpClient } from '@angular/common/http';
import { IdentityVerificationDetails } from '../../interfaces/identity-verification-details/identity-verification-details';
import { Observable } from 'rxjs';
import { IdentityVerificationDetailsForCreation } from '../../interfaces/identity-verification-details/identity-verification-details-for-creation';
import { Utilities } from '../../utilities';
import { IdentityVerificationDetailsForUpdate } from '../../interfaces/identity-verification-details/identity-verification-details-for-update';
import { PatchDocument } from '../../interfaces/patch-document';

@Injectable({
  providedIn: 'root',
})
export class IdentityVerificationDetailsService {

  protected _baseLink: string;

  constructor(
    private http: HttpClient,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    this._baseLink = `${this.config.rootUrl}/Orders`;
  }

  public getIdentityVerificationDetails(orderID: string): Observable<IdentityVerificationDetails> {
    return this.http.get<IdentityVerificationDetails>(`${this._baseLink}/${orderID}/IdentityVerificationDetails`);
  }

  public createIdentityVerificationDetails(orderID: string, details: IdentityVerificationDetailsForCreation): Observable<IdentityVerificationDetails> {
    return this.http.post<IdentityVerificationDetails>(
      `${this._baseLink}/${orderID}/IdentityVerificationDetails`,
      details,
      Utilities.generateHeaders());
  }

  public updateIdentityVerificationDetails(orderID: string, details: IdentityVerificationDetailsForUpdate): Observable<IdentityVerificationDetails> {
    return this.http.put<IdentityVerificationDetails>(
      `${this._baseLink}/${orderID}/IdentityVerificationDetails`,
      details,
      Utilities.generateHeaders());
  }

  public deleteIdentityVerificationDetails(orderID: string): Observable<void> {
    return this.http.delete<void>(`${this._baseLink}/${orderID}/IdentityVerificationDetails`);
  }

  public patchIdentityVerificationDetails(orderID: string, patchDocument: PatchDocument[]): Observable<IdentityVerificationDetails> {
    return this.http.patch<IdentityVerificationDetails>(
      `${this._baseLink}/${orderID}/IdentityVerificationDetails`,
      patchDocument,
      Utilities.generateHeaders());
  }
}
